export interface IPageConfig {
  mostDonors: boolean;
  nationality?: boolean;
  address?: boolean;
  anonymous_from_api?: boolean;
  only_inr?: boolean;
  donate_label?: string;
  tip?: boolean;
  recurring?: boolean;
  passport?: boolean;
  pan?: boolean;
  utm_nudge?: boolean;
  story_link?: boolean;
  most_donors?: boolean;
  pincode?: boolean;
}
export const STORY_CONFIG: IPageConfig = {
  mostDonors: false,
  nationality: true,
  address: true,
  anonymous_from_api: true,
  only_inr: false,
  donate_label: 'Stories.proceedDonate',
  recurring: true,
  utm_nudge: true,
  story_link: true,
  most_donors: true,
  pincode: false,
  pan: true,
  passport: true
};
export const FUNDRAISER_CONFIG: IPageConfig = {
  mostDonors: true,
  nationality: true,
  address: true,
  anonymous_from_api: false,
  only_inr: true,
  donate_label: 'Fundraiser.proceedPay',
  tip: true,
  recurring: false,
  passport: true,
  pan: true,
  utm_nudge: false,
  story_link: false,
  pincode: true
};
export const DEFAULT_CONFIG: IPageConfig = {
  mostDonors: true,
  nationality: true,
  address: true,
  anonymous_from_api: false,
  only_inr: true,
  donate_label: 'Fundraiser.proceedPay',
  tip: true,
  recurring: false,
  passport: true,
  pan: true,
  utm_nudge: false,
  story_link: false,
  pincode: true
};
